exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".clappr-flash-playback[data-flash-playback]{display:block;position:absolute;top:0;left:0;height:100%;width:100%;pointer-events:none}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./src/playbacks/base_flash_playback/public/flash.scss
 ** module id = 134
 ** module chunks = 0
 **/